export const FETCH_STORE_CREDIT_ERROR = 'FETCH_STORE_CREDIT_ERROR'
export const FETCH_STORE_CREDIT_SUCCESS = 'FETCH_STORE_CREDIT_SUCCESS'
export const FETCH_STORE_CREDIT_REQUEST = 'FETCH_STORE_CREDIT_REQUEST'
